module.exports = __webpack_public_path__ + "static/media/2.Portable Battery Sprayer.73941c31.jpg";